<template>
<div >



<!-- MODAL PRICING -->
<modal-pricing v-if="modal.show" v-bind:props="modal"  @close="closeModalPricing()" @update="setPriceList"></modal-pricing>

<div class="card">
  <div class="card-header">
    <product-info class="mt-1" v-bind:productId="product.productId"></product-info>   
    <h4>PREZZO DI ACQUISTO E VENDITA</h4>
  </div>



  <div class="card-body">

    <button type="button" @click="modal.show=true" class="btn btn-info ml-1 mb-1" data-toggle="modal" data-target="#modalPricing">
  <i style="color:beige" class="fas fa-calculator mr-2" aria-hidden="true"></i>
  INSERIMENTO  PREZZO SCONTO E IVA
</button>


<div class="table-responsive-sm mt-1">              
<table class="table table-bordered table-sm" id="priceDetail">
    <thead class="thead-light">
    <tr>
        <th class="text-center"
        
         v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
         v-for="(key,index) in cols" :key="index">
         
       <!-- <small  v-if="key!='Listino'" id="sizeHelp" class="form-text text-muted">Mis.</small> -->
          
        <span v-bind:style="{ color :  key!='COLORE' ? 'black' : 'blue' }"  >{{key.toUpperCase()}}</span>
        </th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, index1) in items" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
            <div v-if="key!='Listino'">
               <input  v-model = "entry[key]" class="form-control inputClass"  v-bind:name="entry['Listino'] + '|' + index2 " type="number" placeholder="" :disabled="key=='Listino'">
            </div>
            <div v-else >
              
              <div  v-if="entry['Listino']=='acquisto'">
                    
                  
                    <span>ACQUISTO €</span> 
   
                                         
                </div>  
   
                   <div v-else>
             
                     <span>VENDITA €</span> 
                       
                   </div>  

                <!--
                <div class="input-group mb-3">
                
                  <div class="input-group-prepend">
                    <span  class="input-group-text" id="basic-addon1">€</span>
                    <span @click="setCalc()" v-if="entry['Listino']=='vendita'" data-toggle="tooltip"  title="Calcola ricarico"  class="input-group-text pointer" id="basic-addon1"><i class="fas fa-calculator mr-2" aria-hidden="true"></i></span>
                  </div>   
                  <input   @change="setMarkUp()" v-focus class="form-control"  v-bind:name="'price_' + entry['Listino']" type="number" v-bind:placeholder="'Pr. di ' + entry['Listino']">
                  <div class="input-group-append">
                    <span @click="repeatPrice(index1)" class="input-group-text pointer" data-toggle="tooltip"  title="Ripeti prezzo per ogni misura"><i class="fas fa-clone mr-2" aria-hidden="true"></i></span>
                  </div>

                </div>
              -->
                 <div class="row ml-3">
               
                 <!-- <discount-list  @update="setDiscountList"></discount-list>  -->
               
                 </div>

                
          </div>
        </td>
      </tr>
    </tbody>
</table>

<span v-if="discountsList" style="font-size: 20px;" class="badge badge-light">Sconto acquisto {{discountsList}}</span>



 

  <alert-box class="mt-1 mb-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button  @click="submit()"  class="btn btn-primary float-right mr-3">
    <i style="color:yellow" class="fas fa-save mr-2" aria-hidden="true"></i>
    TERMINA</button>
  

 </div>

    
  </div>
</div>



</div> 
</template>

<script>



import alertBox         from '@/components/common/AlertBox.vue';
import productInfo      from '@/components/product/ProductInfo.vue';
import keyHandler       from '@/components/mixins/keyHandler'
import ModalPricing     from '@/components/backOffice/ready/ModalPricing.vue';
import { mapGetters }       from 'vuex';

export default {
  
  components: {alertBox,productInfo,ModalPricing},  
  props: ['product'],
  mixins: [keyHandler],
  data () {
  
    return {
    
     modal      : { 'show' : false,'prices':{},'discounts':[]},  
     

     cols       : [],
     items      : [],
     barcodes   : [], 
     msg     : {
       title : '',
       body  : '',
       type  : 0
     },
     
  
     discounts : [],
     discountsList : '',
     vat           : 0

    }
  },
 
  computed:
  {
    ...mapGetters(['company']),
  },
  
   directives: 
    {
      

    },
  mounted()
    {
      
    },
  created()
  {
  
   this.createItems()

  },

  methods: 
  {

    setPriceList(prices,discounts)
    {
      
      $('#modalPricing').modal('hide')
      this.modal.show      = false      
      this.modal.prices    = prices
      this.modal.discounts = discounts
      this.discounts       = discounts
      this.vat             = prices.vat
      this.setDiscountsList()
      
      this.setDataGrid()
    },
    setDiscountsList()
    {
      let list = []
      this.discounts.forEach(item =>{
        list.push(item.discount)
      })
      this.discountsList =  list.join(' + ')
      
    },
    setDataGrid()
      {
        const costPrice = this.modal.prices.price1
        const retailPrice = this.modal.prices.price2

        this.cols.forEach(col =>
          {              
            if (col != 'Listino')
            {
              this.items[0][col] = parseFloat(costPrice).toFixed(2)   
              this.items[1][col] = parseFloat(retailPrice).toFixed(2)   
            }    
          })
        
      },
    closeModalPricing()
    {
      this.modal.show = false
    },

    

    

    setDiscountList(d1,d2,d3)
    {
      this.discounts = {'discount':d1,'discount2':d2,'discount3':d3}
      
    },

    
     formatEuro(v)
    {
      var formatter = new Intl.NumberFormat('de-DE', {
      //style      : 'currency',
      minimumFractionDigits : 2, 
      maximumFractionDigits : 2,
      currency              : 'EUR',

    });

      return formatter.format(v); 
    },
    submit() 
      {

        
         this.msg.title = ''
         this.items.forEach(e =>{
         var priceList = e.Listino
           //console.log(priceList)
         Object.entries(e).forEach(item => {
                      let key   = item[0]
                      let value = item[1]
                      //use key and value here
                      if (key != 'Listino')
                      {
                        
                        if(this.formatEuro(value) == '0,00')
                        {
                          this.msg.title = 'Prezzo di ' + priceList + ' non valido.'
                          this.msg.body = ''
                          this.msg.type = 1
                          
                              
                          //console.log(key,'ERR')
                        }
                        
                        
                      }
          })
        })
        
        if(this.msg.title == '')
        {
          this.updateItems()
        }    
      },  
    createItems()
      {
      
        this.cols    = []
        this.items   = []
        
        var cols  = this.product.sizes

        this.cols.push('Listino')  
        cols.forEach(item =>
        {
          this.cols.push(item.size)
        })
      

        var obj = {'Listino':'acquisto'}
        cols.forEach(item =>
        {
          obj[item.size] = ''; 
        })

        this.items.push(obj)

        var obj = {'Listino':'vendita'}
        
        cols.forEach(item =>
        {
        
          obj[item.size] = ''; 
        })
        
         
        this.items.push(obj)
        this.modal.show = true
   
        this.$nextTick()
          .then(() => {
           $('#modalPricing').modal('show')
        })


      },

      
      updateItems()
      {
        this.barcodes = this.product.barcodes
        const updateArr = (key,value,priceList) =>
        {
          this.barcodes.forEach(item =>
          {
            // ACQUISTO
            if(priceList == 'acquisto')
            {
              if(item.size == key)
              {
                item.costPrice      = value
                item.discount = 0
                item.discount2 = 0
                item.discount3 = 0
                
                this.discounts.forEach(d => {
                  if(d.order_by == 1 )
                  {
                    item.discount = d.discount
                  }
                  
                  if(d.order_by == 2 )
                  {
                    item.discount2  = d.discount
                  }
                  
                  if(d.order_by == 3 )
                  {
                    item.discount3   = d.discount
                  }
                  
                })
                
                item.vat            = this.vat
              }
            }

            // VENDITA
            if(priceList == 'vendita')
            {
              if(item.size == key)
              {
                item.retailPrice = value
              }
            }

          })
        }
        this.items.forEach(e =>{
          var priceList = e.Listino
           //console.log(priceList)
          Object.entries(e).forEach(item => {
                      let key   = item[0]
                      let value = item[1]
                      //use key and value here
                      if (key!='Listino')
                      {
                        updateArr(key,value,priceList)
                        
                      }
          })
        })
      
      
      
      this.$emit('update',this.barcodes)

     
      },
      
     
      


      
  }
  
}
</script>

<style scoped>
.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 14px;
}
.pointer{
  cursor: pointer;
}

</style>